import { lumappsAnalyticsPlugin } from '@lumapps/analytics-tracking/tracking';
import {
    LumappsTrackingAskClickAction,
    TrackingEventType,
    LumappsTrackingCopyAction,
    LumappsTrackingExpandAction,
} from '@lumapps/analytics-tracking/types';

/**
 * Track the ASK_CLICK event, sent when a user clicks on a source/document in an Ask AI answer.
 */
export const trackAskClick = (params: Omit<LumappsTrackingAskClickAction, 'type'>) => {
    const action: LumappsTrackingAskClickAction = {
        type: TrackingEventType.ASK_CLICK,
        ...params,
    };
    return lumappsAnalyticsPlugin.track({ payload: { action } });
};

/**
 * Track the ASK_COPY event, sent when a user copies an Ask AI answer.
 */
export const trackAskCopy = (traceId: string, query: string) => {
    const action: LumappsTrackingCopyAction = {
        type: TrackingEventType.ASK_COPY,
        traceId,
        query,
    };

    return lumappsAnalyticsPlugin.track({ payload: { action } });
};

/**
 * Track the ASK_EXPAND event, sent when a user expands an Ask AI answer.
 */
export const trackAskExpand = (traceId: string, query: string) => {
    const action: LumappsTrackingExpandAction = {
        type: TrackingEventType.ASK_EXPAND,
        traceId,
        query,
    };

    return lumappsAnalyticsPlugin.track({ payload: { action } });
};
